import React from 'react'

const Footer = () => {
  return <div style={{ height: '50px' }}></div>
}

export default Footer